import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "label", "value", "onChange", "error", "id", "placeholder", "slotProps"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import theme from "../../../../theme/theme";
dayjs.extend(utc);
export var FormDatePicker = function (props) {
    var _a = props.name, name = _a === void 0 ? 'Date' : _a, label = props.label, value = props.value, onChange = props.onChange, error = props.error, id = props.id, placeholder = props.placeholder, _b = props.slotProps, slotProps = _b === void 0 ? {} : _b, others = _objectWithoutProperties(props, _excluded);
    var handleDateChange = function (date) {
        var _dayjs$utc;
        if (onChange)
            onChange(null, date && ((_dayjs$utc = dayjs.utc(date)) === null || _dayjs$utc === void 0 ? void 0 : _dayjs$utc.format()), 'selectDate');
    };
    return /*#__PURE__*/ React.createElement(LocalizationProvider, {
        dateAdapter: AdapterDayjs
    }, /*#__PURE__*/ React.createElement(DatePicker, _extends({
        name: name,
        value: value && dayjs(value),
        format: "DD/MM/YYYY",
        formatDensity: "spacious",
        timezone: "system",
        closeOnSelect: false,
        desktopModeMediaQuery: theme.breakpoints.up('sm'),
        slotProps: _objectSpread(_objectSpread({}, slotProps), {}, {
            textField: _objectSpread(_objectSpread({
                id: id,
                size: "small",
                fullWidth: true,
                sx: {
                    mx: 0
                }
            }, slotProps.textField), {}, {
                error: !!error,
                helperText: error,
                placeholder: placeholder
            }),
            field: _objectSpread({
                clearable: true,
                onClear: function (e) { return onChange && onChange(e, null, 'clear'); }
            }, slotProps.field),
            actionBar: {
                actions: ['clear', 'cancel', 'accept'],
                disableSpacing: true
            },
            openPickerButton: _objectSpread({
                id: name + '-open-picker-btn'
            }, slotProps.openPickerButton),
            popper: _objectSpread({
                placement: 'auto'
            }, slotProps.popper)
        }),
        views: ['year', 'month', 'day'],
        onChange: handleDateChange
    }, others)));
};
